import { api } from "api";

export const getNotificationCampaignReach = async (target) => {
    const response = await api.get("api/notification-campaigns/reach", { params: target });
    return response.data;
};

export const createNotificationCampaign = async (data) => {
    const response = await api.post("api/notification-campaigns", data);
    return response.data;
};

export const getNotificationCampaigns = async (params) => {
    const response = await api.get("api/notification-campaigns", { params });
    return response.data;
};

export const getNotificationCampaign = async (campaignId) => {
    const response = await api.get(`api/notification-campaigns/${campaignId}`);
    return response.data;
};

export const getNotificationCampaignRecipients = async (campaignId, params) => {
    const response = await api.get(`api/notification-campaigns/${campaignId}/recipients`, {
        params,
    });
    return response.data;
};

export const resendNotificationCampaignGap = async (campaignId) => {
    const response = await api.post(`api/notification-campaigns/${campaignId}/resend`);
    return response.data;
};
